/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBorderSides = createReactComponent("outline", "border-sides", "IconBorderSides", [["path", { "d": "M4 8v8", "key": "svg-0" }], ["path", { "d": "M20 16v-8", "key": "svg-1" }], ["path", { "d": "M8 4h8", "key": "svg-2" }], ["path", { "d": "M8 20h8", "key": "svg-3" }]]);

export { IconBorderSides as default };
//# sourceMappingURL=IconBorderSides.mjs.map
